import type { ReactNode } from 'react';

import { Button } from 'design-system';
import { Link } from 'react-router';

export interface ActionEmptyStateAction {
  label: string;
  to: string;
  icon: ReactNode;
  variant?: 'text' | 'outlined' | 'contained';
  replace?: boolean;
  onClick?: () => void;
}

export interface ActionEmptyStateProps {
  title: string;
  description: ReactNode;
  actions?: ActionEmptyStateAction[];
}

const getButtonVariant = (variant: ActionEmptyStateAction['variant']) => {
  if (variant === 'outlined') {
    return 'outline' as const;
  }

  if (variant === 'text') {
    return 'ghost' as const;
  }

  return 'default' as const;
};

export const ActionEmptyState = ({ title, description, actions }: ActionEmptyStateProps) => {
  return (
    <div className='flex flex-1 flex-col items-center gap-4 px-4 py-9 text-center'>
      <h2 className='text-2xl font-bold'>{title}</h2>
      <div>{description}</div>
      {actions?.map(action => (
        <Button
          key={action.to}
          className='w-[250px] justify-start bg-white/20 normal-case hover:bg-white/50'
          nativeButton={false}
          render={
            <Link
              replace={action.replace}
              to={action.to}
            />
          }
          variant={getButtonVariant(action.variant)}
          onClick={action.onClick}
        >
          <span data-icon='inline-start'>{action.icon}</span>
          {action.label}
        </Button>
      ))}
    </div>
  );
};
